<template>
  <b-row>
    <b-col>
      <b-card style="
          margin: 0;
          border: 1px solid #2980b9;
          padding: 0 10px;
          cursor: pointer;
        " no-body :class="{ open: visibleBodyOdontograma }">
        <b-card-header style="color: black; font: 45px; padding: 0 1px" :class="{ collapsed: !visibleBodyOdontograma }"
          :aria-expanded="visibleBodyOdontograma ? 'true' : 'false'" role="tab" data-toggle="collapse"
          @click="onVisibleBodyOdontograma(!visibleBodyOdontograma)">
          <span class="lead collapse-title">
            <strong>EVALUACION ODONTOLOGICA </strong>
          </span>
          <i :class="visibleBodyOdontograma
            ? 'fas fa-chevron-up'
            : 'fas fa-chevron-down'
            "></i>
        </b-card-header>
        <b-collapse v-model="visibleBodyOdontograma" role="tabpanel">
          <b-card-body style="padding: 1.5rem">
            <span>Es embarazada?</span>
            <b-form-checkbox switch v-model="odontologica.esEmbarazada">
              <label v-if="odontologica.esEmbarazada" class="text-primary">Si</label>
              <label v-else>No</label>
            </b-form-checkbox>
            <b-tabs>
              <b-tab title="Salud Bucal" class="text-success">
                <SaludBucal :isAuditoria="isAuditoria"  :saludBucalRecibida="saludBucalRecibida" @update-salud-bucal="updateSaludBucal" />
              </b-tab>
              <b-tab title="Sistema Esto.." class="text-success">
                <SistemaEstomatogmatico  :sistemaEstomatogmaticoRecibido="sistemaEstomatogmaticoRecibido" :isAuditoria="isAuditoria"  @update-sistema-estomatogmatico="updateSistemaEstomatogmatico" />
              </b-tab>
              <b-tab title="Odontograma" class="text-success">
                <b-button @click="openModalOdontograma" variant="primary">Completar Odontograma</b-button>
                 <CommentEditor
                v-if="isAuditoria"
                field="odontoGrama"
                :comentarios="comentarios"
              
    />
              </b-tab>
              <b-modal id="modal-odontograma" title="Odontograma" size="xl" scrollable>
                <div>
                  <b-tabs>
                    <b-tab>
                      <Odontograma :esCrear="esCrear" :citaPosterior="citaPosterior"
                        :odontogramaRecibido="odontogramaRecibido" @update-odontograma="updateOdontograma" />
                    </b-tab>
                  </b-tabs>
                </div>
                <template #modal-footer>
                  <b-button variant="secondary" @click="$bvModal.hide('modal-odontograma')">
                    Cancelar
                  </b-button>
                  <b-button variant="primary" @click="guardarOdontograma">
                    Guardar
                  </b-button>
                </template>
              </b-modal>
              <b-tab title="Indices / Exam. comp." class="text-danger">
                <IndicesCpo :isAuditoria="isAuditoria"  :indicesCpoRecibido="indicesCpoRecibido" :exRecibido="exRecibido"
                  @update-indices-cpo="updateIndicesCpo" @update-examenes="updateExamenes" />
              </b-tab>
            </b-tabs>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { addNewOpt } from "@/shared/helpers";
import { mapState } from "vuex";
import Odontograma from "../../../../../citas/components/Odontograma2/Odontograma.vue";
import SaludBucal from "../../../../../citas/components/Odontologia/SaludBucal.vue";
import SistemaEstomatogmatico from "../../../../../citas/components/Odontologia/SistemaEstomatogmatico.vue";
import IndicesCpo from "../../../../../citas/components/Odontologia/IndicesCpo.vue";
import CommentEditor from "../../../../../atencionMedica/components/CommentEditor/CommentEditor.vue";
import { anamnesisService } from "../../../../../atencionMedica/services";

export default {
  name: "SemiologicaOdontologica",

  components: {
    Odontograma,
    SaludBucal,
    SistemaEstomatogmatico,
    IndicesCpo,
    CommentEditor
  },

  props: {
    onlyView: {
      type: Boolean,
      default: false,
    },
    isAuditoria: {
      type: Boolean,
      default: false,
    },
    dataSaved: {
      type: Object,
      default: null,
    },
    esCrear: {
      default: false,
      required: false,
    },
  },

  data() {
    return {
      exRecibido: null,
      citaPosterior: false,
      hydratedOdontogramaId: null,
      dataUpdateada: null,
      visibleBody: true,
      visibleBodyOdontograma: false,
      odontologica: {
        esEmbarazada: false,
        odontograma: null,
        saludBucal: null,
        sistemaEstomatogmatico: null,
        indicesCpo: null,
        examenesComplementarios: null,
      },

      saludBucalRecibida: null,
      odontogramaRecibido: null,
      sistemaEstomatogmaticoRecibido: null,
      indicesCpoRecibido: null,
    };
  },

  methods: {
    async hydrateOdontogramaById(odontogramaId) {
      if (!odontogramaId) return;
      if (this.hydratedOdontogramaId === odontogramaId) return;

      try {
        const response = await anamnesisService.getOdontogramaById(odontogramaId);
        const payload = typeof response?.data === "string"
          ? JSON.parse(response.data)
          : response?.data || null;
        const odontoData = payload?.data?.odontograma;

        if (!odontoData) return;

        this.odontologica = {
          ...this.odontologica,
          odontograma: odontoData,
        };
        this.odontogramaRecibido = odontoData;
        this.dataUpdateada = JSON.parse(JSON.stringify(odontoData));
        this.hydratedOdontogramaId = odontogramaId;
      } catch (error) {
        console.error("Error al hidratar odontograma por id:", error);
      }
    },

    guardarOdontograma() {

      console.log("data updateada", this.dataUpdateada)

      const items = this.odontologica.odontograma?.itemsTabla || [];

      const hayItemsInvalidos = items.some(item => {
        const tieneDiagnostico = item.diagnostico_1 || item.diagnostico_2;
        const tieneProcedimientoCIE = item.procedimiento_cie;
        const esEncontrado = item.encontrado;
        return esEncontrado === false && (!tieneDiagnostico || !tieneProcedimientoCIE);
      });

      if (hayItemsInvalidos) {
        this.$swal.fire({
          icon: "warning",
          title: "Faltan datos",
          text: "Debe ingresar al menos un diagnóstico y un procedimiento CIE en todos los procedimientos antes de guardar.",
          confirmButtonText: "Entendido",
        });
        return;
      }

      // ✅ Actualizamos solo aquí
      this.odontologica.odontograma = { ...this.dataUpdateada }

      if (this.esCrear) {
        localStorage.setItem("odontograma", JSON.stringify(this.dataUpdateada));
      }

      this.$bvModal.hide("modal-odontograma");
    },


    updateOdontograma(data) {
      this.dataUpdateada = data;
      this.odontologica.odontograma = data;
    },
    updateSaludBucal(data) {
      this.odontologica = {
        ...this.odontologica,
        saludBucal: data
      }

    },
    updateSistemaEstomatogmatico(data) {

      this.odontologica = {
        ...this.odontologica,
        sistemaEstomatogmatico: data
      }

    },
    updateIndicesCpo(data) {
      this.odontologica.indicesCpo = data;
    },
    updateExamenes(data) {

      this.odontologica = {
        ...this.odontologica,
        examenesComplementarios: data
      }
    },

    onVisibleBody(value) {
      this.visibleBody = value;
    },

    openModalOdontograma() {
      if (this.esCrear) {
        const stored = localStorage.getItem("odontograma");
        if (stored) {
          try {
            const parsed = JSON.parse(stored);
            this.odontogramaRecibido = parsed;
            this.dataUpdateada = JSON.parse(JSON.stringify(parsed));
          } catch (e) {
            console.error("Error al parsear el odontograma guardado", e);
          }
        }
      } else {
        // Siempre que no es crear, asegúrate de pasar los datos actualizados
        if (this.odontologica?.odontograma) {

          this.odontogramaRecibido = this.odontologica.odontograma;
          console.log("ENTRA AAAA", this.odontogramaRecibido)

          this.dataUpdateada = JSON.parse(JSON.stringify(this.odontologica.odontograma));
        }
      }

      this.$bvModal.show("modal-odontograma");
    },


    onVisibleBodyOdontograma(value) {
      this.visibleBodyOdontograma = value;
    },

    onAddNewOpt(newValue) {
      return addNewOpt(newValue);
    },
  },

  computed: {
    ...mapState({
      stDataDoctor: (state) => state.atencionCita.dataCita?.doctor,
      stItemsOdontograma: (state) => state.atencionCita?.semiologias?.semActual?.data?.odontograma,
      stDataSemiologia: (state) => state.atencionCita?.semiologias?.semActual?.data,
    }),

    esOdontologia() {
      return this.stDataDoctor?.especialidad?.codEsp === "0000000134";
    },
  },

  watch: {
     isAuditoria: {
      deep:true,
      immediate:true,
      handler(nv){
        console.log("es auditoria sem odonto", nv)
      }
    },



    odontologica: {
      deep: true,
      immediate: true,
      handler(newValue) {

        if (!this.esOdontologia) return;

        let nueva_data = { ...newValue }

        this.$store.commit("setSemOdontologica", nueva_data);

        const data = {
          tipo: "odontologica",
          data: newValue,
        };



        this.$store.commit("setSemActual", data);
      },
    },

    dataSaved: {
      deep: true,
      immediate: true,
      async handler(newValue) {
        // Solo si aún no se ha seteado localmente
        if (newValue && !this.odontologica.odontograma) {
          this.odontologica = newValue;

          this.exRecibido = newValue.examenesComplementarios;
          this.saludBucalRecibida = newValue.saludBucal;
          this.odontogramaRecibido = newValue.odontograma;
          this.indicesCpoRecibido = newValue.indicesCpo;
          this.sistemaEstomatogmaticoRecibido = newValue.sistemaEstomatogmatico;
          this.citaPosterior = true;

          await this.hydrateOdontogramaById(newValue?.odontograma_id);
        }


      },
    },

    stDataSemiologia: {
      deep: true,
      immediate: true,
      async handler(newValue) {
        const odontogramaId = newValue?.odontograma_id;
        if (!odontogramaId) return;
        await this.hydrateOdontogramaById(odontogramaId);
      },
    },
  },
};
</script>
